export default function getClearanceLevel(state) {
  return state.getIn(['currentUser', 'data', 'clearance_level'], 0);
}
